const global_pointer = {
  api: "https://api.myfitnesscoach.fit/api/",
  imgURL: "https://api.myfitnesscoach.fit/",
  url: "https://myfitnesscoach.fit/"
}
export default global_pointer;